import React from "react";

// react-router-dom
import { Routes, Route } from "react-router-dom";

// componentsß
import "antd/dist/antd.css";

// page
import Home from "./components/Home";
import Product from "./components/Product";
import Cart from "./components/Cart";
import Order from "./components/Order";
import Info from "./components/Info";
import Notify from "./components/Notify";
import Event from "./components/Event";
import Maintain from "./components/Maintain";
import Verify from "./components/Verify";

function App() {
  return (
    <div>
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route exact path="/:refcode" element={<Home />} />
        <Route exact path="/event/products/:event/:id" element={<Product />} />
        <Route exact path="/products/:id" element={<Product />} />
        <Route exact path="/products/:id/:refcode" element={<Product />} />
        <Route exact path="/cart" element={<Cart />} />
        <Route exact path="/order" element={<Order />} />
        <Route exact path="/info" element={<Info />} />
        <Route exact path="/notify" element={<Notify />} />
        <Route exact path="/events/:id" element={<Event />} />
        <Route exact path="/events/:id/:refcode" element={<Event />} />
        <Route exact path="/maintain" element={<Maintain />} />
        <Route exact path="/verify" element={<Verify />} />
        {/* <Route exact path="/verify/:refcode" element={<Verify />} /> */}
      </Routes>
    </div>
  );
}

export default App;
